/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { useClassName } from "./FlexItem.mappers";
import { FlexItemProps } from "./FlexItemProps";

/**
 * Renders the FlexItem component.
 * @param props The properties.
 * @returns The FlexItem component.
 */
export const FlexItem: React.FC<FlexItemProps> = props => {
    const { children } = props;
    const className = useClassName(props);

    return <div className={className}>{children}</div>;
};
